
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BLOCKLY_LABEL_PROPERTES, BlocklyToolboxCategory } from "../blocky-types.types";
export const OVERLAY_PLACEMENT = "Ort: {{?placement:dropdown=Über_Chat|'botview',Über_Fusionview|'fusionview'}}";
export function BlocklyCategory_OVERLAYS(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.OVERLAYS, name: name, contents: [] };

  // DEPRECATED - nur noch für bestehende Workspaces registriert
  BH.overlay("OVERLAY_TEXT_BTN", "{{title}}\nButtons {{buttons:statement[@check=BUTTON]}}" + OVERLAY_PLACEMENT, "await RAGAI.OVERLAY.setPlacement({{placement}});\n RAGAI.OVERLAY.textAndButton({{title}},[{{buttons}}]); \n");
  BH.overlay("OVERLAY_PROMPT", "Nutzereingabe {{title}}\nButtons {{buttons:statement[@check=BUTTON]}} " + OVERLAY_PLACEMENT, "await RAGAI.OVERLAY.setPlacement({{placement}});\n RAGAI.OVERLAY.prompt({{title}},[{{buttons}}]); \n");
  BH.overlay("OVERLAY_TEXT", "Text {{title}}\n" + OVERLAY_PLACEMENT, "await RAGAI.OVERLAY.setPlacement({{placement}});\n RAGAI.OVERLAY.text({{title}}); \n");

  // Registriert für Suche, aber nicht im Flyout
  BH._custom("OVERLAY_PROMPT_INPUT", "@output:String\nWert aus Nutzereingabe Overlay", "await RAGAI.OVERLAY.prompt_getInputValue()", { colour: BLOCKLY_COLORS.OVERLAYS });

  // DEPRECATED - nur registriert für bestehende Workspaces
  BH.toastr("TOASTR_PRECONF", "Toastr {{mode:dropdown=🟩-Success|success,🟥-Error|error,🟦-Info|info,🟨-Warning|warning}}:\nTitel {{ title }}\nNachricht {{ msg }}", "RAGAI.toastr.{{ mode }}({{ title }}, {{ msg }}, { disableTimeOut: 'extendedTimeOut', tapToDismiss: false, progressBar: true });");

  cat.contents = [
    BH.label(name),
    { kind: 'block', type: 'OVERLAY_CLOSE' } as any,
    BH.withNested(
      BH.overlay("OVERLAY_HTML", "HTML {{title}}\n" + OVERLAY_PLACEMENT + "\nCSS-Klasse: {{?css}}", "await RAGAI.OVERLAY.setPlacement({{placement}});\n RAGAI.OVERLAY.html({{title}}, null, {{css}}); \n"),
      [{ forValue: 'title', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: '<h1>Hallo Nutzer</h1><span>Wie ist dein Name?</span>' } }]
    ),
    BH.withNested(
      BH.overlay("STAGE_OVERLAY", "Stage Auswahl als Overlay {{title}}\nCSS-Klasse: {{?css}}", "await RAGAI.OVERLAY.stageList({{title}}, {{css}});"),
      [{ forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bitte wählen" } }]
    ),
    BH.withNested(
      BH.overlay("OVERLAY_LOADING", "Ladeanzeige {{text}}\n " + OVERLAY_PLACEMENT + "\nCSS-Klasse: {{?css}}", "await RAGAI.OVERLAY.setPlacement({{placement}});\n await RAGAI.OVERLAY.loading({{text}}, {{css}});"),
      [{
        forValue: 'text',
        isShadow: false,
        targetBlockType: BLOCKLY_DUMMY.STRING,
        targetBlockDefaults: { text: "Bitte Warten..." }
      }]),
    BH.label("Overlay Vorlagen"),
    {
      kind: 'block', type: 'OVERLAY_TEXT_BTN_NEW',
      extraState: { inputCount: 2, placementExpanded: false },
      inputs: {
        TITLE: {
          block: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Wähle eine Option' }
          },

        },
        ADD0: {
          block: {
            type: 'RAGAI_BUTTON_OUTPUT_NEW',
            inputs: {
              TEXT: {
                block: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Option A' }
                },
                shadow: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Option A' }
                }
              }
            }
          }
        },
        ADD1: {
          block: {
            type: 'RAGAI_BUTTON_OUTPUT_NEW',
            inputs: {
              TEXT: {
                block: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Option B' }
                },
                shadow: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Option B' }
                }
              }
            }
          }
        }
      }
    } as any,


    {
      kind: 'block', type: 'OVERLAY_PROMPT_NEW',
      extraState: { inputCount: 2, placementExpanded: false },
      inputs: {
        TITLE: {
          block: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Wie ist dein Name?' }
          },
          shadow: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Wie ist dein Name?' }
          }
        },
        ADD0: {
          block: {
            type: 'RAGAI_BUTTON_OUTPUT_NEW',
            inputs: {
              TEXT: {
                block: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Senden' }
                },
                shadow: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Senden' }
                }
              },
              ACTION: {
                block: {
                  type: 'BOTMESSAGE_BLOCK',
                  inputs: {
                    value: {
                      block: {
                        type: 'text_join_plus_minus',
                        extraState: { inputCount: 3 },
                        inputs: {
                          ADD0: {
                            block: {
                              type: BLOCKLY_DUMMY.STRING,
                              fields: { text: 'Der Nutzer hat ' }
                            }
                          },
                          ADD1: {
                            block: {
                              type: 'OVERLAY_PROMPT_INPUT'
                            }
                          },
                          ADD2: {
                            block: {
                              type: BLOCKLY_DUMMY.STRING,
                              fields: { text: ' eingegeben' }
                            }
                          }
                        }
                      }
                    }
                  },
                  next: {
                    block: {
                      type: 'OVERLAY_CLOSE'
                    }
                  }
                }
              }
            }
          }
        },
        ADD1: {
          block: {
            type: 'RAGAI_BUTTON_OUTPUT_NEW',
            inputs: {
              TEXT: {
                block: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Abbrechen' }
                },
                shadow: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Abbrechen' }
                }
              },
              ACTION: {
                block: {
                  type: 'OVERLAY_CLOSE'
                }
              }
            }
          }
        }
      }
    } as any,


    BH.label("Benachrichtigungen"),
    {
      kind: 'block', type: 'TOASTR_PRECONF_NEW',
      extraState: { optionsExpanded: false },
      inputs: {
        TITLE: {
          block: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Hinweis' }
          }
        },
        MSG: {
          block: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Aktion erfolgreich ausgeführt' }
          }
        }
      }
    } as any
  ];

  cat.contents.push();


  return cat;
}
